// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import Auth from 'containers/Auth/Auth'
import SitePlayer from 'components/NowPlaying/SitePlayer'
import MyStation from 'components/MyStation/MyStation'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import MobileAppBackButton from 'components/MobileAppMenu/MobileAppBackButton'
import MobileAppSetStationNudge from 'components/MobileAppMenu/MobileAppSetStationNudge'
import MobileAppMenu from 'components/MobileAppMenu/MobileAppMenu'
import Menu from 'components/menu/menu'
import NowPlaying from 'components/NowPlaying/NowPlaying'
import Footer from 'components/Footer/Footer'
import AppBanner from 'components/AppBanner/AppBanner'
import LoginNudgeModal from 'components/LoginNudgeModal/LoginNudgeModal'
import BadgeAwardModal from 'components/BadgeAwardModal/BadgeAwardModal'
import ProgramMenu from 'components/ProgramMenu/ProgramMenu'
import HomeLayout from 'layouts/HomeLayout'
import MainLayout from 'layouts/MainLayout'
import ListenPage from 'views/page/mobile-app/ListenPage'
import HelpPage from 'views/page/mobile-app/HelpPage'
import NewsPage from 'views/page/mobile-app/NewsPage'
import InfoPage from 'views/page/mobile-app/InfoPage'
// import MorePage from 'views/page/mobile-app/MorePage'
import NowPlayingPage from 'views/page/mobile-app/NowPlayingPage'
import VerseListPage from 'views/page/mobile-app/VerseListPage'
import VersePage from 'views/page/mobile-app/VersePage'
import EmbeddedPlayer from 'views/embed/EmbeddedPlayer'
import SiteNotice from 'components/SiteNotice/SiteNotice'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import { getUrlParameter } from 'utilities/url'

// Redux:
import { getScreenSize, getShareLinkData } from 'actions/site'
import { getFullScheduleData, getStationsData, setSiteId } from 'actions/schedule'
import { getProgramsData } from 'actions/programs'
import { getFacebookData } from 'actions/facebook'
import { getPageData } from 'actions/page'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	constructor( props ) {
		super( props )

		const { location } = props

		this.isNativeApp = getUrlParameter( 'native-app' )
		this.isEmbeddedPlayer = false

		if ( '/player-embed/' == location.pathname || '/player-embed' == location.pathname ) {
			this.isEmbeddedPlayer = true
		}
	}

	componentDidMount() {
		// Get data:
		this.props.getProgramsData()

		if ( ! this.isEmbeddedPlayer ) {
			const siteId = getUrlParameter( 'siteid' )

			if ( siteId ) {
				this.props.setSiteId( siteId )
			}

			this.props.getFullSchedule()
			this.props.getFacebookData()
			this.props.getStationsData()
			this.props.getPost( 'home', 'page', false, true )

			const shareId = getUrlParameter( 'share_id' )

			if ( shareId ) {
				this.props.getShareLinkData( shareId )
			}
		}

		window.addEventListener( 'resize', this.onResize )
	}

	componentDidUpdate( prevProps ) {
		const { siteId, timezoneOffset, getFullSchedule } = this.props

		if ( siteId && siteId != prevProps.siteId ) {
			getFullSchedule()
		}

		if ( timezoneOffset != prevProps.timezoneOffset ) {
			getFullSchedule()
		}
	}

	onResize = () => {
		this.props.getScreenSize()
	}

	scrollToTop = () => {
		zenscroll.toY( 0, 100 )
	}

	render() {
		const { appMode, isMobile, isIos, siteId, hasSidebar, accountDropdownIsOpen, scrollTopButtonVisibility, page, location, match, isPlaying, nowPlaying, showBadgeAwardModal, showLoginNudgeModal, loggedIn, siteNotice } = this.props
		let className = '/' == location.pathname ? 'site-wrap is-home' : 'site-wrap'
		let showSetStationNudge = false
		let scrollTopButtonClass = scrollTopButtonVisibility ? 'scroll-top-button is-active' : 'scroll-top-button'
		let isSingleProgram = false

		if ( this.isEmbeddedPlayer ) {
			return <EmbeddedPlayer { ...this.props } />
		}

		if ( appMode ) {
			className += ' app-mode'
		}

		if ( isIos ) {
			className += ' is-ios'
		}

		if ( siteId ) {
			className += ' with-site-id'
		} else {
			className += ' without-site-id'
		}

		if ( accountDropdownIsOpen ) {
			className += ' with-account-dropdown-open'
		}

		if ( '/schedule/' == location.pathname || '/schedule' == location.pathname ) {
			className += ' page-schedule'
		}

		if ( '/stations/' == location.pathname || '/stations' == location.pathname ) {
			className += ' page-stations'
		}

		if ( '/votd/' == location.pathname || '/votd' == location.pathname ) {
			className += ' page-votd'
		}

		if ( '/about-us/' == location.pathname || '/about-us' == location.pathname ) {
			className += ' page-about-us'
		}

		if ( location.pathname.indexOf( '/votd/2' ) > -1 ) {
			className += ' page-verse'
		}

		if ( location.pathname.indexOf( '/program/' ) > -1 || location.pathname.indexOf( '/programs/' ) > -1 ) {
			className += ' page-program'
		}

		if ( /\/programs?\/\w/.test( location.pathname ) ) {
			isSingleProgram = true
		}

		if ( this.isNativeApp ) {
			className += ' native-app-mode'
		}

		if ( '/' == location.pathname || '/listen/' == location.pathname || '/listen' == location.pathname ) {
			showSetStationNudge = true
		}

		return (
			<div className={ className }>
				<Auth />

				<ErrorBoundary>
					<SitePlayer { ...this.props } />
				</ErrorBoundary>

				<div className="site">
					{ ! this.isNativeApp &&
						<AppBanner />
					}

					{ appMode &&
						<MobileAppMenu { ...this.props } />
					|| ! this.isNativeApp &&
						<HeaderMobilePrimary />
					}

					{ showBadgeAwardModal &&
						<BadgeAwardModal />
					}

					{ ( showLoginNudgeModal && ! loggedIn ) &&
						<LoginNudgeModal />
					}

					{ ( siteNotice && siteNotice.isOpen ) &&
						<SiteNotice
							heading={ siteNotice.heading }
							text={ siteNotice.text }
							cancelText={ siteNotice.cancelText }
							handleCancel={ null }
						 />
					}

					<ProgramMenu isSingleProgram={ isSingleProgram } />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						{ ! appMode &&
							<div className="sub-header-doppelganger"></div>
						}

						{ ! appMode &&
							<div className="sub-header">
								<Menu mobileMenu={ false } />
							</div>
						}

						{ ! appMode &&
							<HeaderPrimary />
						}

						{ appMode &&
							<div className="mobile-app-top-bar">
								<MobileAppBackButton location={ location } />

								{ showSetStationNudge &&
									<MobileAppSetStationNudge />
								}

								<MyStation />
							</div>
						}

						<div className={ scrollTopButtonClass } onClick={ this.scrollToTop }>
							<i className="icon-chevron-down" aria-hidden="true"></i>
						</div>

						<section className="main">
							<Switch>
								{ appMode &&
									[
										<Route key="home" path="/" exact component={ ListenPage } />,
										<Route key="listen" path="/listen" exact component={ ListenPage } />,
										<Route key="now-playing" path="/now-playing" exact component={ NowPlayingPage } />,
										<Route key="votd" path="/votd" exact component={ VerseListPage } />,

										<Route key="help" path="/help" exact component={ HelpPage } />,
										<Route key="news" path="/news" exact component={ NewsPage } />,
										<Route key="info" path="/info" exact component={ InfoPage } />
									]
								||
									<Route path="/" exact component={ HomeLayout } />
								}

								<Route path="/signin" exact render={ props => (
									<Auth login={ true } />
								)} />
								<Route path="/signup" exact render={ props => (
									<Auth signup={ true } />
								)} />
								<Route path="/signout" exact render={ props => (
									<Auth logout={ true } />
								)} />
								<Route path="/:page" exact component={ MainLayout } />
								<Route path="/votd/:verse" exact component={ VersePage } />,
								<Route path="/program/:program" exact component={ MainLayout } />
								<Route path="/programs/:program" exact component={ MainLayout } />
								<Route path="/schedule-item/:time" exact component={ MainLayout } />
								<Route path="/votd-schedule" exact component={ MainLayout } />
								<Route path="/votd-schedule/:date" exact component={ MainLayout } />
								<Route path="/news/:blog" exact component={ MainLayout } />
								<Route path="/blog/:blog" exact component={ MainLayout } />
								<Route path="/event/:event" exact component={ MainLayout } />
								<Route path="/:page/page/:archivePageNumber" exact component={ MainLayout } />
								<Route path="/:parent/:page" exact component={ MainLayout } />
								<Route component={ MainLayout } />
							</Switch>
						</section>
					</div>
				</div>

				{ ! appMode &&
					<Footer />
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		appMode: state.site.appMode,
		isMobile: state.site.isMobile,
		isIos: state.site.isIos,
		siteNotice: state.site.siteNotice,
		isPlaying: state.schedule.isPlaying,
		siteId: state.schedule.siteId,
		timezoneOffset: state.schedule.timezoneOffset,
		nowPlaying: state.schedule.nowPlaying,
		hasSidebar: state.site.hasSidebar,
		accountDropdownIsOpen: state.site.accountDropdownIsOpen,
		scrollTopButtonVisibility: state.site.scrollTopButtonVisibility,
		showBadgeAwardModal: state.site.showBadgeAwardModal,
		showLoginNudgeModal: state.site.showLoginNudgeModal,
		loggedIn: state.site.loggedIn,
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getScreenSize() {
			dispatch( getScreenSize() )
		},

		setSiteId( siteId ) {
			dispatch( setSiteId( siteId ) )
		},

		getFullSchedule() {
			dispatch( getFullScheduleData() )
			dispatch( getFullScheduleData( 0, 0, 1, 'back' ) )
			dispatch( getFullScheduleData( 0, 0, 1, 'forward' ) )
		},

		getProgramsData() {
			dispatch( getProgramsData() )
		},

		getFacebookData() {
			dispatch( getFacebookData() )
		},

		getStationsData() {
			dispatch( getStationsData() )
		},

		getPost( slug, type, archivePageNumber = false, requestOnly = false ) {
			dispatch( getPageData( slug, type, archivePageNumber, requestOnly ) )
		},

		getShareLinkData( id ) {
			dispatch( getShareLinkData( id ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( SiteLayout )
